import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'currencyAmount',
    pure: true,
    standalone: false
})
@Injectable({
  providedIn: 'root'
})
export class CurrencyAmountPipe implements PipeTransform {
  transform(
    value: number | string | null | undefined,
    symbol: string = '$',
    fixedDecimals: boolean = false
  ): string {
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    const num =
      typeof value === 'string'
        ? Number(value.split(' ')[0])
        : Number(value);

    if (isNaN(num) || num === 0) {
      return '-';
    }

    const hasDecimals = num % 1 !== 0;
    const formatted = num.toLocaleString('en-US', {
      minimumFractionDigits: fixedDecimals || hasDecimals ? 2 : 0,
      maximumFractionDigits: 2
    });

    const normalized = symbol.trim().toLowerCase();
    const displaySymbol = normalized.startsWith('usd') || normalized === 'usdt' ? '$' : symbol;

    return `${displaySymbol}${formatted}`;
  }
}
